export default {
  age_gate: {
    AF: "AF|Afghanistan|18|no|y||1|1|en|en",
    AL: "AL|Albania|18|yes|y||1|1|en|en",
    DZ: "DZ|Algeria|18|no|y||1|1|en|en",
    AD: "AD|Andorra|18|yes|y||1|1|en|en",
    AO: "AO|Angola|18|yes|y||1|1|en|en",
    AG: "AG|Antigua and Barbuda|18|yes|y||1|1|en|en",
    AR: "AR|Argentina|18|yes|y||1|1|en|en",
    AM: "AM|Armenia|18|yes|y||1|1|en|en",
    AU: "AU|Australia|18|yes|y||1|1|en|en",
    AT: "AT|Austria|18|yes|y||1|1|en|en",
    AZ: "AZ|Azerbaidjan|18|yes|y||1|1|en|en",
    BS: "BS|Bahamas|18|yes|y||1|1|en|en",
    BH: "BH|Bahrain|21|yes|y||1|1|en|en",
    BD: "BD|Bangladesh|18|no|y||1|1|en|en",
    BB: "BB|Barbados|18|yes|y||1|1|en|en",
    BY: "BY|Belarus|18|no|y||1|1|en|en",
    BE: "BE|Belgium|18|yes|y||1|1|en|en",
    BZ: "BZ|Belize|18|yes|y||1|1|en|en",
    BJ: "BJ|Benin|18|yes|y||1|1|en|en",
    BT: "BT|Bhutan|18|yes|y||1|1|en|en",
    BO: "BO|Bolivia|18|yes|y||1|1|en|en",
    BA: "BA|Bosnia and Herzegovina|18|yes|y||1|1|en|en",
    BW: "BW|Botswana|18|yes|y||1|1|en|en",
    BR: "BR|Brazil|18|yes|y||1|1|en|en",
    BN: "BN|Brunei Darussalam|18|no|y||1|1|en|en",
    BG: "BG|Bulgaria|18|no|y||1|1|en|en",
    BF: "BF|Burkina Faso|18|yes|y||1|1|en|en",
    BI: "BI|Burundi|18|yes|y||1|1|en|en",
    KH: "KH|Cambodia|21|yes|y||1|1|en|en",
    CM: "CM|Cameroon|21|yes|y||1|1|en|en",
    CA: "CA|Canada|19|yes|y||1|1|en|en",
    CV: "CV|Cape Verde|18|yes|y||1|1|en|en",
    CF: "CF|Central African Republic|18|yes|y||1|1|en|en",
    TD: "TD|Chad|18|yes|y||1|1|en|en",
    CL: "CL|Chile|18|yes|y||1|1|en|en",
    CN: "CN|China Mainland|18|yes|y||1|1|en|en",
    CO: "CO|Colombia|18|yes|y||1|1|en|en",
    KM: "KM|Comoros|21|yes|y||1|1|en|en",
    CR: "CR|Costa Rica|18|yes|y||1|1|en|en",
    HR: "HR|Croatia|18|yes|y||1|1|en|en",
    CU: "CU|Cuba|18|yes|y||1|1|en|en",
    CY: "CY|Cyprus|18|yes|y||1|1|en|en",
    CZ: "CZ|Czech Republic|18|yes|y||1|1|en|en",
    DK: "DK|Denmark|18|yes|y||1|1|en|en",
    DJ: "DJ|Djibouti|18|yes|y||1|1|en|en",
    DM: "DM|Dominica|18|yes|y||1|1|en|en",
    DO: "DO|Dominican Republic|18|yes|y||1|1|en|en",
    CG: "CG|DR Congo|18|yes|y||1|1|en|en",
    TL: "TL|East Timor|18|yes|y||1|1|en|en",
    EC: "EC|Ecuador|18|yes|y||1|1|en|en",
    EG: "EG|Egypt|18|no|y||1|1|en|en",
    SV: "SV|El Salvador|18|yes|y||1|1|en|en",
    GQ: "GQ|Equatorial Guinea|21|yes|y||1|1|en|en",
    ER: "ER|Eritrea|18|yes|y||1|1|en|en",
    EE: "EE|Estonia|18|no|y||1|1|en|en",
    ET: "ET|Ethiopia|18|no|y||1|1|en|en",
    FJ: "FJ|Fiji|18|yes|y||1|1|en|en",
    FI: "FI|Finland|20|yes|y||1|1|en|en",
    FR: "FR|France|18|yes|y||1|1|fr|fr",
    GA: "GA|Gabon|18|yes|y||1|1|en|en",
    GM: "GM|Gambia|18|no|y||1|1|en|en",
    DE: "DE|Germany|18|yes|y||1|1|en|en",
    GH: "GH|Ghana|18|yes|y||1|1|en|en",
    GR: "GR|Greece|18|yes|y||1|1|en|en",
    GD: "GD|Grenada|18|yes|y||1|1|en|en",
    GT: "GT|Guatemala|18|yes|y||1|1|en|en",
    GN: "GN|Guinea|18|yes|y||1|1|en|en",
    GW: "GW|Guinea-Bissau|21|yes|y||1|1|en|en",
    GY: "GY|Guyana|18|yes|y||1|1|en|en",
    HT: "HT|Haiti|18|yes|y||1|1|en|en",
    HN: "HN|Honduras|18|yes|y||1|1|en|en",
    HK: "HK|Hong Kong S.A.R|18|yes|y||1|1|en|en",
    HU: "HU|Hungary|18|yes|y||1|1|en|en",
    IS: "IS|Iceland|20|no|y||1|1|en|en",
    IN: "IN|India|25|no|y||1|1|en|en",
    ID: "ID|Indonesia|21|no|y||1|1|en|en",
    IR: "IR|Iran|18|no|y||1|1|en|en",
    IQ: "IQ|Iraq|18|no|y||1|1|en|en",
    IE: "IE|Ireland|18|yes|y||1|1|en|en",
    IL: "IL|Israel|18|yes|y||1|1|en|en",
    IT: "IT|Italy|18|yes|y||1|1|it|it",
    CI: "CI|Ivory Coast|18|yes|y||1|1|en|en",
    JM: "JM|Jamaica|18|yes|y||1|1|en|en",
    JP: "JP|Japan|20|yes|y||1|1|*|ja-jp",
    JO: "JO|Jordan|18|no|y||1|1|en|en",
    KZ: "KZ|Kazakhstan|21|yes|y||1|1|en|en",
    KE: "KE|Kenya|18|yes|y||1|1|en|en",
    KI: "KI|Kiribati|21|yes|y||1|1|en|en",
    KW: "KW|Kuwait|18|no|y||1|1|en|en",
    KG: "KG|Kyrgyzstan|18|no|y||1|1|en|en",
    LA: "LA|Lao PDR|18|yes|y||1|1|en|en",
    LV: "LV|Latvia|18|yes|y||1|1|en|en",
    LB: "LB|Lebanon|18|yes|y||1|1|en|en",
    LS: "LS|Lesotho|18|yes|y||1|1|en|en",
    LR: "LR|Liberia|18|yes|y||1|1|en|en",
    LY: "LY|Libya|18|no|y||1|1|en|en",
    LI: "LI|Liechtenstein|18|yes|y||1|1|en|en",
    LT: "LT|Lithuania|20|yes|y||1|1|en|en",
    LU: "LU|Luxembourg|18|yes|y||1|1|en|en",
    MO: "MO|Macao S.A.R|18|yes|y||1|1|en|en",
    MK: "MK|Macedonia|18|yes|y||1|1|en|en",
    MG: "MG|Madagascar|18|yes|y||1|1|en|en",
    MW: "MW|Malawi|18|yes|y||1|1|en|en",
    MY: "MY|Malaysia|21|no|y||1|1|en|en",
    MV: "MV|Maldives|18|no|y||1|1|en|en",
    ML: "ML|Mali|18|yes|y||1|1|en|en",
    MT: "MT|Malta|18|yes|y||1|1|en|en",
    MH: "MH|Marshall Islands|18|yes|y||1|1|en|en",
    MR: "MR|Mauritania|18|no|y||1|1|en|en",
    MU: "MU|Mauritius|18|no|y||1|1|en|en",
    MX: "MX|Mexico|18|yes|y||1|1|en|en",
    FM: "FM|Micronesia|21|yes|y||1|1|en|en",
    MD: "MD|Moldova|18|yes|y||1|1|en|en",
    MC: "MC|Monaco|18|yes|y||1|1|en|en",
    MN: "MN|Mongolia|18|yes|y||1|1|en|en",
    ME: "ME|Montenegro|18|yes|y||1|1|en|en",
    MA: "MA|Morocco|20|yes|y||1|1|en|en",
    MZ: "MZ|Mozambique|18|yes|y||1|1|en|en",
    MM: "MM|Myanmar|18|yes|y||1|1|en|en",
    NA: "NA|Namibia|18|yes|y||1|1|en|en",
    NR: "NR|Nauru|18|yes|y||1|1|en|en",
    NP: "NP|Nepal|18|no|y||1|1|en|en",
    NL: "NL|Netherlands|18|yes|y||1|1|en|en",
    NZ: "NZ|New Zealand|18|yes|y||1|1|en|en",
    NI: "NI|Nicaragua|19|yes|y||1|1|en|en",
    NE: "NE|Niger|18|yes|y||1|1|en|en",
    NG: "NG|Nigeria|18|yes|y||1|1|en|en",
    KP: "KP|North Korea|18|yes|y||1|1|en|en",
    NO: "NO|Norway|20|yes|y||1|1|en|en",
    OM: "OM|Oman|21|no|y||1|1|en|en",
    PK: "PK|Pakistan|21|no|y||1|1|en|en",
    PW: "PW|Palau|21|yes|y||1|1|en|en",
    PA: "PA|Panama|18|yes|y||1|1|en|en",
    PG: "PG|Papua New Guinea|18|yes|y||1|1|en|en",
    PY: "PY|Paraguay|20|yes|y||1|1|en|en",
    PE: "PE|Peru|18|yes|y||1|1|en|en",
    PH: "PH|Philippines|18|yes|y||1|1|en|en",
    PL: "PL|Poland|18|yes|y||1|1|en|en",
    PT: "PT|Portugal|18|yes|y||1|1|en|en",
    QA: "QA|Qatar|19|no|y||1|1|en|en",
    RO: "RO|Romania|18|yes|y||1|1|en|en",
    RU: "RU|Russia|18|yes|y||1|1|en|en",
    RW: "RW|Rwanda|18|yes|y||1|1|en|en",
    KN: "KN|Saint Kitts and Nevis|18|yes|y||1|1|en|en",
    LC: "LC|Saint Lucia|18|yes|y||1|1|en|en",
    VC: "VC|Saint Vincent & the Grenadines|18|yes|y||1|1|en|en",
    WS: "WS|Samoa|21|yes|y||1|1|en|en",
    SM: "SM|San Marino|18|yes|y||1|1|en|en",
    ST: "ST|Sao Tome and Principe|18|yes|y||1|1|en|en",
    SA: "SA|Saudi Arabia|18|no|y||1|1|en|en",
    SN: "SN|Senegal|18|yes|y||1|1|en|en",
    RS: "RS|Serbia|18|yes|y||1|1|en|en",
    SC: "SC|Seychelles|18|yes|y||1|1|en|en",
    SL: "SL|Sierra Leone|18|yes|y||1|1|en|en",
    SG: "SG|Singapore|18|yes|y||1|1|en|en",
    SK: "SK|Slovakia|18|yes|y||1|1|en|en",
    SI: "SI|Slovenia|18|no|y||1|1|en|en",
    SB: "SB|Solomon Islands|21|yes|y||1|1|en|en",
    SO: "SO|Somalia|18|no|y||1|1|en|en",
    ZA: "ZA|South Africa|18|yes|y||1|1|en|en",
    KR: "KR|South Korea|19|yes|y||1|1|ko|ko",
    ES: "ES|Spain|18|yes|y||1|1|en|en",
    LK: "LK|Sri Lanka|21|yes|y||1|1|en|en",
    SD: "SD|Sudan|18|no|y||1|1|en|en",
    SR: "SR|Suriname|18|yes|y||1|1|en|en",
    SZ: "SZ|Swaziland|18|yes|y||1|1|en|en",
    SE: "SE|Sweden|20|no|y||1|1|en|en",
    CH: "CH|Switzerland|18|yes|y||1|1|en|en",
    SY: "SY|Syria|18|no|y||1|1|en|en",
    TW: "TW|Taiwan Region|18|yes|y||1|1|en|en",
    TJ: "TJ|Tajikistan|18|no|y||1|1|en|en",
    TZ: "TZ|Tanzania|18|yes|y||1|1|en|en",
    TH: "TH|Thailand|20|yes|y||1|1|en|en",
    TG: "TG|Togo|21|yes|y||1|1|en|en",
    TO: "TO|Tonga|21|yes|y||1|1|en|en",
    TT: "TT|Trinidad and Tobago|18|yes|y||1|1|en|en",
    TN: "TN|Tunisia|18|yes|y||1|1|en|en",
    TR: "TR|Turkey|18|yes|y||1|1|en|en",
    TM: "TM|Turkmenistan|18|no|y||1|1|en|en",
    TV: "TV|Tuvalu|18|yes|y||1|1|en|en",
    UG: "UG|Uganda|18|yes|y||1|1|en|en",
    UA: "UA|Ukraine|18|yes|y||1|1|en|en",
    AE: "AE|United Arab Emirates|21|no|y||1|1|en|en",
    GB: "GB|United Kingdom|18|yes|y||1|1|en,fr,it,jp,ko,de|en",
    UY: "UY|Uruguay|18|yes|y||1|1|en|en",
    US: "US|USA|21|yes|mdy||1|1|en|en",
    UZ: "UZ|Uzbekistan|20|yes|y||1|1|en|en",
    VU: "VU|Vanuatu|18|yes|y||1|1|en|en",
    VE: "VE|Venezuela|18|yes|y||1|1|en|en",
    VN: "VN|Vietnam|18|no|y||1|1|en|en",
    YE: "YE|Yemen|18|no|y||1|1|en|en",
    ZM: "ZM|Zambia|18|yes|y||1|1|en|en",
    ZW: "ZW|Zimbabwe|18|yes|y||1|1|en|en",
  }
}
